import Icon from 'veui/components/Icon'

Icon.register({
  macos: {
    paths: [
      {
        d: 'M384 32C189.6 32 32 189.6 32 384s157.6 352 352 352 352-157.6 352-352S578.4 32 384 32zm122.68 561.08L384 421.32 261.32 593.08H208L357.34 384 208 174.92h53.32L384 346.68l122.68-171.76H560L410.66 384 560 593.08z'
      }
    ],
    width: '768',
    height: '768'
  }
})
